/* istanbul ignore file */
import { appStorage } from '../utils';
import { nullLocation } from './utils';

export const makeNullIfNeeded = val => (
  val === 'null' || val === null || val === undefined ? null : val
);

export const putInStorage = location => {
  location.latitude && appStorage.setItem('covid_latitude', location.latitude);
  location.longitude && appStorage.setItem('covid_longitude', location.longitude);
  location.place && appStorage.setItem('covid_place', location.place);
  location.add && appStorage.setItem('covid_add', location.add);
  location.pincode && appStorage.setItem('covid_pincode', location.pincode);
};

export const clearFromStorage = key => {
  appStorage.removeItem(key);
};
export const updateInStorage = (key, val) => {
  appStorage.setItem(key, val);
};

export const getObjectFromStorage = key => appStorage.getItem(key);

export const readFromStorage = () => {
  const latitude = appStorage.getItem('covid_latitude');
  const longitude = appStorage.getItem('covid_longitude');
  const place = appStorage.getItem('covid_place');
  const add = appStorage.getItem('covid_add');
  const pincode = appStorage.getItem('covid_pincode');
  return {
    latitude: makeNullIfNeeded(latitude),
    longitude: makeNullIfNeeded(longitude),
    place: makeNullIfNeeded(place),
    add: makeNullIfNeeded(add),
    pincode: makeNullIfNeeded(pincode)
  };
};

export const getLocationFromStore = () => {
  const latitude = appStorage.getItem('covid_latitude');
  const longitude = appStorage.getItem('covid_longitude');
  const pincode = appStorage.getItem('covid_pincode');
  const add = appStorage.getItem('covid_add');

  if (latitude && longitude) {
    return {
      add: makeNullIfNeeded(add),
      pincode: makeNullIfNeeded(pincode),
      latitude: (makeNullIfNeeded(latitude) ? Number(latitude) : null),
      longitude: (makeNullIfNeeded(longitude) ? Number(longitude) : null)
    };
  }
  return nullLocation;
};

export const clearAll = () => {
  const allLocationKeys = Object.keys(readFromStorage() || {});
  allLocationKeys.forEach(key => clearFromStorage(key));
};

export const isUserAddressAvailable = () => {
  const locationData = readFromStorage();
  if (locationData.covid_place && locationData.covid_add) return true;
  return false;
};
export const isLocationDataAvailable = () => {
  let isAvailable = true;
  const locationData = readFromStorage();
  Object.values(locationData).some(val => {
    if (!val) {
      isAvailable = false;
      return true;
    }
    return false;
  });
  return isAvailable;
};